import { render, staticRenderFns } from "./App.vue?vue&type=template&id=05a1d8bd&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./app.css?vue&type=style&index=0&id=05a1d8bd&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a1d8bd",
  null
  
)

export default component.exports